import { errorLoggingService } from 'src/services/errorLoggingService';
import type { SignalRMessageType } from 'src/types/Dto/SignalRMessageType';

export type SignalRDiagnosticEvent =
    | 'negotiate_failure'
    | 'connection_closed'
    | 'connection_stop_failure'
    | 'group_join_failure'
    | 'handler_failure';

interface SignalRDiagnosticContext {
    vesselImoNumber?: number;
    reason?: 'network' | 'offline_simulated' | 'unknown';
    messageType?: SignalRMessageType;
}

const getSessionId = (): string => {
    const key = 'signalRDiagnosticSessionId';
    const existingSessionId = sessionStorage.getItem(key);
    if (existingSessionId) {
        return existingSessionId;
    }

    const sessionId = crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(key, sessionId);
    return sessionId;
};

/**
 * The approved BrowserError/AppLog path only supports bounded failure diagnostics.
 * Never pass an exception, token, connection ID, or SignalR payload to this helper.
 */
export const logSignalRDiagnostic = (event: SignalRDiagnosticEvent, context: SignalRDiagnosticContext = {}): void => {
    const safeContext = [
        `event=${event}`,
        `session=${getSessionId()}`,
        context.vesselImoNumber ? `vessel=${context.vesselImoNumber}` : '',
        context.reason ? `reason=${context.reason}` : '',
        context.messageType ? `messageType=${context.messageType}` : '',
    ]
        .filter(Boolean)
        .join(';');

    errorLoggingService.logError('unhandledrejection', `SignalR ${event.replaceAll('_', ' ')}`, safeContext);
};
